import { Component, input } from '@angular/core';
import { DmLogo } from '@digitale-menschen/component-library-angular';

export type LexplusLogoVariant = 'full' | 'compact';
export type LexplusLogoAppearance = 'default' | 'on-brand';

/**
 * Neosys × Lexplus brand logo. Wraps the library's `dm-logo` layout primitive,
 * projecting the Neosys mark and the Lexplus wordmark into its `mark`/`type`
 * slots so ratio, gap and the full/compact behaviour come from the design system.
 *
 * - `variant="full"` shows mark + wordmark, `variant="compact"` shows the mark only.
 * - `appearance="on-brand"` renders the wordmark and Neosys lettering in white for
 *   use on brand-coloured surfaces (e.g. the admin sidebar); the coloured mark tiles
 *   and the Swiss cross keep their brand colours.
 */
@Component({
  selector: 'lp-logo',
  imports: [DmLogo],
  templateUrl: './lexplus-logo.component.html',
  styleUrl: './lexplus-logo.component.scss',
  host: {
    '[class.lp-logo--on-brand]': "appearance() === 'on-brand'",
  },
})
export class LexplusLogoComponent {
  public readonly variant = input<LexplusLogoVariant>('full');
  public readonly appearance = input<LexplusLogoAppearance>('default');
}
